import React from 'react';
import Component from '@/Component';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';
import { DateUtils } from 'react-day-picker';
import dateFnsFormat from 'date-fns/format';
import dateFnsParse from 'date-fns/parse';

const parseDate = (str, format, locale) => {
  const parsed = dateFnsParse(str, format, { locale });
  if (DateUtils.isDate(parsed)) {
    return parsed;
  }
  return undefined;
}

const formatDate = (date, format, locale) => {
  return dateFnsFormat(date, format, { locale });
}

const FORMAT = 'YYYYMMDD'

class DateInput extends Component {
  render() {
    return (
      <input style={{backgroundColor: this.props.disabled ? '#e9ecef' : '#fff'}} className="form-control" placeholder={FORMAT} {...this.props} readOnly />
    )
  }
}

class DatePickerComponent extends Component {
  render() {
    return (
      <DayPickerInput 
        component={DateInput}
        onDayChange={this.props.onDayChange}
        dayPickerProps={{
          todayButton: 'Today',
        }}
        inputProps={{
          disabled: this.props.disabled
        }}
        formatDate={formatDate}
        format={FORMAT}
        parseDate={parseDate}
        value={this.props.date}
      />
    )
  }
}

export default DatePickerComponent;


// WEBPACK FOOTER //
// ./src/components/customized/DatePicker.js